(function () {
  var myVar = setInterval(timer, 100);
  function timer() {
    if (window.jQuery) {
      $(document).ready(function () {
        $(document).on("swell:setup", function() {
          if(spapi.authenticated) {
            Swell.Cart.items.forEach(function(item) {
              if (item.properties._swell_discount_type == "cart_fixed_amount") {
                redeemedRedemptionOption = swellAPI.findActiveRedemptionOptionById(item.properties._swell_redemption_option_id);
                if(swellCheckCart() == false){
                  swellAPI.removeRedemptionOptionIdFromCart(redeemedRedemptionOption.id, function(){});
                  if(window.location.href.indexOf("cart") == -1) {
                    window.location.relod();
                  }
                }
                return;
              }
            });
          }
        });
      });
      stop();
    }
  }
  function stop() {
    clearInterval(myVar);
  }
}).call(this);

function swellCheckCart() {
  var cart_Total = 0;
  var legal = true;
  Swell.Cart.items.forEach(function(item) {
    cart_Total+= item.original_price * item.quantity;
  });
  Swell.Cart.items.forEach(function(item) {
    if (item.properties._swell_discount_type == "cart_fixed_amount") {
      redeemedRedemptionOption = swellAPI.findActiveRedemptionOptionById(item.properties._swell_redemption_option_id);
      if(parseFloat(redeemedRedemptionOption.icon) > cart_Total/100){
        legal = false;
      }
    }
  });
  return legal;
}